"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

var _react = _interopRequireDefault(require("react"));

require("../activity.scss");

const {
  Option
} = _select.default;
const {
  Item
} = _form.default;

const CategoryQuestion = props => {
  const {
    question,
    onTextChange,
    updateQuestion,
    options,
    disabled
  } = props;
  const {
    text,
    correctOptionId,
    id,
    uuid
  } = question;

  const onCorrectOptionChange = value => {
    question.correctOptionId = value;
    updateQuestion(question);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(Item, {
    key: `category-question-text-${id || uuid}`,
    name: `category-question-text-${id || uuid}`,
    rules: [{
      required: true,
      message: 'Questions must have text.'
    }],
    initialValue: text
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    spellCheck: true,
    disabled: disabled,
    placeholder: "Question text",
    onChange: onTextChange,
    style: {
      width: '100%'
    }
  })), /*#__PURE__*/_react.default.createElement(Item, {
    key: `category-question-correct-option-${id || uuid}`,
    name: `category-question-correct-option-${id || uuid}`,
    rules: [{
      required: true,
      message: 'Category questions must have a correct option defined.'
    }],
    initialValue: correctOptionId ? `${correctOptionId}` : undefined,
    label: "Correct Option:"
  }, /*#__PURE__*/_react.default.createElement(_select.default, {
    disabled: disabled,
    onChange: onCorrectOptionChange,
    style: {
      width: 'auto',
      minWidth: '200px'
    }
  }, options === null || options === void 0 ? void 0 : options.map(option => /*#__PURE__*/_react.default.createElement(Option, {
    value: `${option.id ? option.id : option.uuid}`
  }, option.text)))));
};

var _default = CategoryQuestion;
exports.default = _default;